import { h } from '../';
export const selectTemplates = (state) => {
    const templates = state.templates;
    if (!h.isLoaded(templates)) {
        return null;
    }
    return templates.data;
};
export const selectTemplatesMap = (state) => {
    const templatesMap = state.templatesMap;
    return templatesMap || {};
};
export const selectGroupedTemplates = (state) => {
    const templates = selectTemplates(state);
    const groupedTemplates = [];
    if (templates && templates.length > 0) {
        templates &&
            templates.map((template) => {
                groupedTemplates.push(template);
            });
    }
    return Object.values(groupedTemplates.reduce((acc, t) => {
        acc[t.templateId] = t;
        return acc;
    }, {}));
};
//# sourceMappingURL=selectors.js.map